import { joinRequestUseCase } from '@/domain/use-cases/join-request.use-case';
import { JoinRequestResult } from '@/entities/JoinRequestResult';

export const joinRequestController = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	teamUuid: string,
	teamLeagueTradeRequestUuid: string,
	action: string
): Promise<JoinRequestResult> => {
	return joinRequestUseCase(organizationUuid, teamLeagueUuid, teamUuid, teamLeagueTradeRequestUuid, action);
};
